const saveMessage = (axios, { name, message }) => {
  return axios.post(`saved`, { name, message });
};

const deleteMessage = (axios, id) => {
  return axios.delete(`saved/${id}`);
};

export { saveMessage, deleteMessage };
